"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.search");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.load = load;
exports.loadCurrent = loadCurrent;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _constants = require("./constants");

function resolveURL(location) {
  if (location && typeof location !== 'string') {
    throw new Error('Error: location argument should be a non-empty string');
  }

  var currentUrl = window.location.href;

  if (location) {
    var _context, _context2;

    currentUrl = (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(window.location.protocol, "//")).call(_context2, window.location.host)).call(_context, location);
  }

  if (window.location.hostname === 'localhost') {
    var _context3, _context4;

    var path = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(window.location.pathname)).call(_context4, window.location.search)).call(_context3, window.location.hash);
    currentUrl = "https://ci.onvio.us/staff/#".concat(location ? location : path);
  }

  return encodeURIComponent(currentUrl);
}

function getHelp(_x) {
  return _getHelp.apply(this, arguments);
}

function _getHelp() {
  _getHelp = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(parameters) {
    var _context5;

    return _regenerator.default.wrap(function _callee2$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", fetch((0, _concat.default)(_context5 = "".concat(_constants.helpUrl)).call(_context5, parameters), {
              headers: (0, _utils.jsonHeaders)()
            }).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
                return _regenerator.default.wrap(function _callee$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        return _context6.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee2);
  }));
  return _getHelp.apply(this, arguments);
}

function load(_x2) {
  return _load.apply(this, arguments);
}

function _load() {
  _load = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(location) {
    var parameters;
    return _regenerator.default.wrap(function _callee3$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            parameters = "?location=".concat(resolveURL(location));
            return _context8.abrupt("return", getHelp(parameters));

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee3);
  }));
  return _load.apply(this, arguments);
}

function loadCurrent() {
  return _loadCurrent.apply(this, arguments);
}

function _loadCurrent() {
  _loadCurrent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", getHelp("?location=".concat(encodeURIComponent(window.location.href))));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee4);
  }));
  return _loadCurrent.apply(this, arguments);
}
